import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Force scroll to top instantly on every path change
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0; // For Safari
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
